import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { dateFormatter } from '../../../../../helpers/dateFormatter'
import StateContext from '../../../../../StateContext'
import FavoriteFixtureAPI from '../../../../Profile/FavoriteFixtureAPI'
import FixtureCountdown from './FixtureDateHandler/FixtureCountdown'
import FixtureGoals from './FixtureGoals'
import FixtureProgressBar from './SingleFixture/FixtureProgressBar'

function FixtureMain({ fixture, formatDateShort }) {
    const [fixtureObj, setFixtureObj] = useState(fixture)
    function calcTime(time) {
        const percentageElapsed = time / 90
        console.log(percentageElapsed * 100)
        return percentageElapsed * 100
    }

    useEffect(() => {
        if (fixture) {
            setFixtureObj(fixture)
        } else {
            setFixtureObj({
                league_id: 1,
                homeTeam: {},
                awayTeam: {},
                statusShort: '',
                elapsed: 0,
            })
        }
    }, [fixture])

    const appState = useContext(StateContext)

    return (
        <div className="row bg-white pt-1">
            <div className="col-4 text-center">
                <Link to={`/teams-api/${fixtureObj?.homeTeam?.team_id}`}>
                    <img src={fixtureObj?.homeTeam?.logo} />
                    <p className="font-weight-bold">
                        {fixtureObj?.homeTeam?.team_name}
                    </p>
                </Link>
            </div>
            <div className="col-4 text-center">
                <br />
                <div className="text-center">
                    <small>
                        {fixtureObj?.elapsed &&
                        fixtureObj?.elapsed > 0 &&
                        fixtureObj?.elapsed <= 90 &&
                        fixtureObj?.statusShort !== 'FT' &&
                        fixtureObj?.statusShort !== 'PST' &&
                        fixtureObj?.statusShort !== 'HT' ? (
                            <>
                                <span className="text-success">
                                    {fixtureObj?.elapsed + "'"}{' '}
                                    <i className="fas fa-circle-notch fa-spin"></i>
                                </span>
                            </>
                        ) : (
                            dateFormatter(fixtureObj?.event_date)
                        )}
                        <FixtureCountdown
                            dateFixture={fixtureObj?.event_date}
                        />
                        {fixtureObj?.statusShort === 'PST' && 'Postponed'}
                        {fixtureObj?.statusShort !== 'NS' &&
                            fixtureObj?.statusShort}
                    </small>
                </div>
                <div className="text-center">
                    <small>
                        <Link to={`/leagues/${fixtureObj?.league_id}`}>
                            {fixtureObj?.league?.name}{' '}
                        </Link>{' '}
                    </small>
                </div>
                <h2 className="font-weight-bold mt-4">
                    {fixture?.goalsHomeTeam} - {fixture?.goalsAwayTeam}
                </h2>
            </div>
            <div className="col-4 text-center">
                <Link to={`/teams-api/${fixture?.awayTeam?.team_id}`}>
                    <img src={fixture?.awayTeam?.logo} />
                    <p className="font-weight-bold">
                        {fixture?.awayTeam?.team_name}
                    </p>
                </Link>
            </div>
            {appState.loggedIn && (
                <div className="col-12 py-3">
                    <FavoriteFixtureAPI
                        fixture={fixture}
                        fixtureId={fixture?.fixture_id}
                    />
                </div>
            )}

            <div className="col-12 pt-4">
                <FixtureGoals fixture={fixture} />
                <FixtureProgressBar value={50} />
                <hr
                    style={{
                        float: 'left',
                        width: `${calcTime(fixture.elapsed)}%`,
                        color: 'red',
                        borderTop: '15px solid #007bff',
                        marginTop: '-23px',
                    }}
                />
            </div>
        </div>
    )
}
export default FixtureMain
